import React from "react";

import { FilterToggleButtonGroup, StyledToggleButton } from "./FilterToggleInput";

export const TerminalToggleButtonGroup = ({ terminals, value, onChange, optionName = "name", optionValue = "id", disabled = false, ...rest }) => {
	const handleChange = (event, newValue) => {
		onChange(event, newValue);
	};

	return (
		<FilterToggleButtonGroup value={value} exclusive onChange={handleChange} {...rest}>
			{terminals.map((terminal) => (
				<StyledToggleButton value={terminal[optionValue]} key={String(terminal[optionValue])} disabled={disabled}>
					{terminal[optionName].toUpperCase()}
				</StyledToggleButton>
			))}
		</FilterToggleButtonGroup>
	);
};
